import React from 'react';
import { Card, Typography, Divider } from 'antd';
import './ProfessionalLayout.css';

const { Title, Text } = Typography;

const ProfessionalLayout = ({ 
  title, 
  subtitle, 
  icon, 
  children, 
  headerActions,
  loading = false,
  className = ''
}) => {
  return (
    <div className={`professional-layout ${className}`}>
      <Card 
        className="professional-card"
        bordered={false}
        loading={loading}
      >
        <div className="professional-header">
          <div className="professional-title-section">
            {icon && (
              <div className="professional-icon">
                {icon}
              </div>
            )}
            <div className="professional-title-content">
              <Title level={3} className="professional-title">
                {title}
              </Title>
              {subtitle && (
                <Text type="secondary" className="professional-subtitle">
                  {subtitle}
                </Text>
              )}
            </div>
          </div>
          {headerActions && (
            <div className="professional-actions">
              {headerActions}
            </div>
          )}
        </div>
        
        {(title || subtitle || headerActions) && <Divider />}
        
        <div className="professional-content">
          {children}
        </div>
      </Card>
    </div>
  );
};

export default ProfessionalLayout; 